/* global zaraz */
// import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { getEncryptedEmail } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/utils';
import runAfterNextPaint from '@PROJECT_ROOT/assets/responsive-frontend/js/services/runAfterNextPaint';

// Ovdje su navedeni svi eventi koje koristimo.
export const ACCOMMODATION_LINK_ABOVE_GUIDE_ARTICLE_CLICK = 'AccommodationLinkAboveGuideArticleClick';
export const MAIN_MENU_CLICK = 'MainMenuClick';
export const ARTICLE_SOCIAL_SHARE = 'ArticleSocialShare';
export const PROVIDER_ACQUISITION_HEADER_CLICK = 'ProviderAcquisitionHeaderClick';
export const PROVIDER_ACQUISITION_MENU_CLICK = 'ProviderAcquisitionMenuClick';
export const UNIT_PRESENTATION_SIGN_IN_CLICK = 'UnitPresentationSignInClick';
export const HOMEPAGE_AI_SEARCH_BUTTON = 'HomepageAISearchButton';
export const SEARCH_RESULTS_FACILITY_CLICK = 'SearchResultsFacilityClick';
export const SEARCH_RESULTS_FACILITY_TITLE_LINK = 'SearchResultsFacilityTitleLink';
export const SEARCH_RESULTS_FACILITY_IMAGE_LINK = 'SearchResultsFacilityImageLink';
export const SEARCH_RESULTS_UNIT_IMAGE_LINK = 'SearchResultsUnitImageLink';
export const SEARCH_RESULTS_UNIT_TITLE_LINK = 'SearchResultsUnitTitleLink';
export const SEARCH_RESULTS_UNIT_CTA_LINK = 'SearchResultsUnitCTALink';
export const SEARCH_RESULTS_CARD_EMPTY_SPACE_LINK = 'SearchResultsCardEmptySpaceLink';
export const VIRTUAL_PAGE_VIEW = 'virtualPageView';
export const CHECKOUT_SECOND_STEP = 'checkoutSecondStep';
export const PARTNER_CHECKOUT_SECOND_STEP = 'partnerCheckoutSecondStep';
export const CHECKOUT_FIRST_STEP = 'checkoutFirstStep';
export const PARTNER_CHECKOUT_FIRST_STEP = 'partnerCheckoutFirstStep';
export const PARTNER_CHECKOUT_FINAL_STEP = 'partnerCheckoutFinalStep';
export const CHECKOUT_THIRD_STEP = 'checkoutThirdStep';
export const CHECKOUT_NEW_USER = 'checkoutNewUser';
export const CHECKOUT_PROMO_CODE = 'checkoutPromoCode';
export const PARTNER_CHECKOUT_PROMO_CODE = 'partnerCheckoutPromoCode';
export const CHECKOUT_LOGIN = 'checkoutLogin';
export const CHECKOUT_BACK_TO_FACILITY = 'checkoutBackToFacility';
export const PARTNER_CHECKOUT_BACK_TO_FACILITY = 'partnerCheckoutBackToFacility';
export const WHATSAPP_ICON_CHECKOUT_CLICK = 'WhatsAppIconCheckoutClick';
export const PURCHASE = 'purchase';
export const ADD_PAYMENT_INFO = 'add_payment_info';
export const BEGIN_CHECKOUT = 'begin_checkout';
export const ADD_SHIPPING_INFO = 'add_shipping_info';
export const CONTACT_FORM_ACCOMMODATION_CLICK = 'ContactFormAccommodationClick';
export const EBOOK_DOWNLOAD_CLICK = 'ebook_download_click';
export const UNIT_PRESENTATION_UNIT_CARD_TITLE_LINK_TO_PRESENTATION_CLICK = 'unitPresentationUnitCardTitleLinkToPresentationClick';
export const RESERVATION_FORM_UNIT_CARD_UNIT_DETAILS = 'ReservationFormUnitCardUnitDetails';
export const RESERVATION_FORM_UNIT_CARD_PERSONS_EDIT = 'reservationFormUnitCardPersonsEdit';
export const RESERVATION_FORM_UNIT_CARD_REMOVE_UNIT = 'ReservationFormUnitCardRemoveUnit';
export const RESERVATION_FORM_UNIT_CARD_REMOVE_MAIN_UNIT = 'reservationFormUnitCardRemoveMainUnit';
export const RESERVATION_FORM_UNIT_CARD_ADD_UNIT = 'ReservationFormUnitCardAddUnit';
export const RESERVATION_FORM_REMOVE_UNIT = 'ReservationFormRemoveUnit';
export const RESERVATION_FORM_REMOVE_MAIN_UNIT = 'reservationFormRemoveMainUnit';
export const RESERVATION_FORM_PERSONS_EDIT = 'reservationFormPersonsEdit';
export const QUICK_MENU_CLICK = 'HomepageQuickMenuClick';
export const HOMEPAGE_SEARCH_QUICK_LINK_CLICK = 'HomepageSearchQuickLinkClick';
export const LOYALTY_CLICK = 'HomepageLoyaltyClick';
export const FOOTER_NEWSLETTER_SUBSCRIBE_SUBMIT = 'FooterNewsletterSubscribeSubmit';
export const HOMEPAGE_NEWSLETTER_SUBSCRIBE_SUBMIT = 'HomepageNewsletterSubscribeSubmit';
export const HOMEPAGE_SEARCH_QUICK_LINK_CLICK_DETAILED = 'HomepageSearchQuickLinkClickDetailed';
export const PILLAR_PAGE_SEARCH_QUICK_LINK_CLICK_DETAILED = 'PillarPageSearchQuickLinkClickDetailed';
export const SEARCH_RESULTS_QUICK_SEARCH_SUBMIT_DETAILED = 'SearchResultsQuickSearchSubmitDetailed';
export const SEARCH_ACTION = 'searchAction';
export const HOMEPAGE_QUICK_SEARCH_SUBMIT = 'HomepageQuickSearchSubmit';
export const PILLAR_PAGE_QUICK_SEARCH_SUBMIT = 'PillarPageQuickSearchSubmit';
export const MOBILE_DOCK_QUICK_SEARCH_SUBMIT = 'MobileDockQuickSearchSubmit';
export const SEARCH_RESULTS_QUICK_SEARCH_SUBMIT = 'SearchResultsQuickSearchSubmit';
export const SELECT_ITEM = 'select_item';
export const SPECIAL_OFFER = 'HomepageSpecialOffer';
export const TOP_DESTINATION = 'HomepageTopDestination';
export const UNIT_PRESENTATION_UNIT_DETAILS_LINK_TO_PRESENTATION_CLICK = 'unitPresentationUnitDetailsLinkToPresentationClick';
export const VACATION_SUGGESTION = 'HomepageVacationSuggestion';
export const SEARCH_EVENT = 'search-event';
export const LANGUAGE_SWITCHER_DOCK_CLICK = 'LanguageSwitcherDockClick';
export const LANGUAGE_SWITCHER_HEADER_CLICK = 'LanguageSwitcherHeaderClick';
export const QUICK_SEARCH_START_DATE_ONLY_SELECTED = 'QuickSearchStartDateOnlySelected';
export const WHATSAPP_ICON_CONTACT_CLICK = 'WhatsAppIconContactClick';
export const RESERVATION_FORM_DATES_ON_CALENDAR_SELECTED = 'reservationFormDatesOnCalendarSelected';
export const UNIT_PRESENTATION_LAST_MINUTE_INTERVAL_SELECT = 'unitPresentationLastMinuteIntervalSelect';
export const UNIT_PRESENTATION_QUICK_MENU_SELECT_SECTION = 'unitPresentationQuickMenuSelectSection';
export const RESERVATION_FORM_MOBILE_DOCK_OPEN = 'reservationFormMobileDockOpen';
export const UNIT_PRESENTATION_AMENITY_DETAILS_OPEN = 'unitPresentationAmenityDetailsOpen';
export const UNIT_PRESENTATION_MAIN_GALLERY_OPEN = 'unitPresentationMainGalleryOpen';
export const RESERVATION_FORM_DETAILED_PRICE_CALCULATION = 'reservationFormDetailedPriceCalculation';
export const RESERVATION_FORM_GLOBAL_DATES_SELECTED = 'ReservationFormGlobalDatesSelected';
export const RESERVATION_FORM_GLOBAL_PERSONS_SELECTED = 'ReservationFormGlobalPersonsSelected';
export const RESERVATION_FORM_BOOK_NOW_CTA_CLICK = 'reservationFormBookNowCTAClick';
export const UNIT_PRESENTATION_ROOM_DETAILS_OPEN = 'unitPresentationRoomDetailsOpen';
export const UNIT_PRESENTATION_PRICELIST_CAPACITY_SELECTED = 'unitPresentationPricelistCapacitySelected';
export const UNIT_PRESENTATION_OTHER_BEACHES_OPEN = 'unitPresentationOtherBeachesOpen';
export const LINKEDIN_INSIGHT_TRIGGER = 'linkedinInsightTrigger';
export const JOB_APPLICATION_SUBMIT = 'JobApplicationSubmit';
export const PAGE_NEWSLETTER_SUBSCRIBE_SUBMIT = 'PageNewsletterSubscribeSubmit';
export const SEARCH_RESULTS_FILTERS_SUBMIT = 'SearchResultsFiltersSubmit';
export const SEARCH_RESULTS_FILTERS_MODAL = 'searchResultsFilterModal';
export const SEARCH_RESULTS_LOAD_MORE = 'searchResultsLoadMore';
export const SEARCH_RESULTS_MAP_VIEW = 'searchResultsMapView';
export const UNIT_PRESENTATION_MAIN_BEACH_GALLERY_NEXT = 'unitPresentationMainBeachGalleryNext';
export const CLOSEST_BEACH = 'closestBeach';
export const OTHER_BEACHES = 'otherBeaches';
export const UNIT_PRESENTATION_REVIEWS_FROM_GRADE_OPEN = 'unitPresentationReviewsFromGradeOpen';
export const UNIT_PRESENTATION_REVIEWS_FROM_SHOW_MORE_OPEN = 'unitPresentationReviewsFromShowMoreOpen';
export const UNIT_PRESENTATION_MAP_LOCATION_FROM_OVERVIEW_OPEN = 'unitPresentationMapLocationFromOverviewOpen';
export const UNIT_PRESENTATION_MAP_LOCATION_FROM_LOCATION_OPEN = 'unitPresentationMapLocationFromLocationOpen';
export const UNIT_PRESENTATION_OTHER_BEACHES_GALLERY_NEXT = 'unitPresentationOtherBeachesGalleryNext';
export const VIEW_ITEM_LIST = 'view_item_list';
export const VIEW_ITEM = 'view_item';
export const ADD_TO_CART = 'add_to_cart';
export const REMOVE_FROM_CART = 'remove_from_cart';
export const VIEW_CART = 'view_cart';
export const REGISTER_USER = 'register-user';
export const PROVIDER_LOGIN_PAGE_FORGOTTEN_PASSWORD_LINK_CLICK = 'ProviderLoginPageForgottenPasswordLinkClick';
export const PROVIDER_LOGIN_PAGE_REGISTRATION_LINK_CLICK = 'ProviderLoginPageRegistrationLinkClick';
export const PROVIDER_LOGIN_PAGE_INFO_BOX_REGISTRATION_LINK_CLICK = 'ProviderLoginPageInfoBoxRegistrationLinkClick';
export const PROVIDER_LOGIN_PAGE_INFO_BOX_BLOG_LINK_CLICK = 'ProviderLoginPageInfoBoxBlogLinkClick';
export const PROVIDER_REGISTRATION_PAGE_GOOGLE_LOGIN_CLICK = 'ProviderRegistrationPageGoogleLoginClick';
export const PROVIDER_LOGIN_PAGE_GOOGLE_LOGIN_CLICK = 'ProviderLoginPageGoogleLoginClick';
export const PROVIDER_LOGIN_PAGE_FACEBOOK_LOGIN_CLICK = 'ProviderLoginPageFacebookLoginClick';
export const PROVIDER_REGISTRATION_PAGE_FACEBOOK_LOGIN_CLICK = 'ProviderRegistrationPageFacebookLoginClick';
export const PROVIDER_REGISTRATION_PAGE_EXISTING_USER_CLICK = 'ProviderRegistrationPageExistingUserClick';
export const SHIPPING_INFO_COUNTRY_ERROR = 'ShippingInfoCountryError';
export const ADD_TO_WISHLIST = 'add_to_wishlist';
export const AI_SEARCH_NEW_CONVERSATION_CLICK = 'AISearchNewConversationClick';
export const AI_SEARCH_RESULTS_ARROW_CLICK = 'AISearchResultsArrowClick';
export const AI_SEARCH_RESULTS_SCROLL = 'AISearchResultsScroll';
export const AI_SEARCH_RESULTS_GALLERY = 'AISearchResultsGallery';
export const AI_SEARCH_RESULTS_UNIT_CLICK = 'AISearchResultsUnitClick';
export const AI_SEARCH_CONTINUE_WITH_FILTERS_CLICK = 'AISearchContinueWithFiltersClick';
export const AI_SEARCH_LINK_IN_TEXT_CLICK = 'AISearchLinkInTextClick';
export const AI_SEARCH_RESULTS_VIEW_ITEM_LIST = 'AISearchResultsViewItemList';
export const RESERVATION_CALCULATION_PRICE_DETAILS_OPEN = 'ReservationCalculationPriceDetailsOpen';
export const RESERVATION_CALCULATION_PAYMENT_SCHEDULE_OPEN = 'ReservationCalculationPaymentScheduleOpen';
export const RESERVATION_CALCULATION_CANCELLATION_POLICY_OPEN = 'ReservationCalculationCancellationPolicyOpen';
export const WISHLIST_FILTER_LOCATION_SELECTED = 'WishlistFilterLocationSelected';
export const WISHLIST_FILTER_DATES_SELECTED = 'WishlistFilterDatesSelected';
export const WISHLIST_FILTER_PERSONS_SELECTED = 'WishlistFilterPersonsSelected';
export const WISHLIST_SELECT_ITEM = 'WishlistSelectItem';
export const QUICK_SEARCH_SUGGESTED_LOCATION_SELECTED = 'QuickSearchSuggestedLocationSelected';
export const PROFILE_MENU_OPEN = 'ProfileMenuOpen';
export const PROFILE_MENU_LINK_SELECTED = 'ProfileMenuLinkSelected';
export const MAIN_MENU_OPEN = 'MainMenuOpen';
export const MAIN_MENU_LINK_SELECTED = 'MainMenuLinkSelected';
export const UNIT_PRESENTATION_DESCRIPTION_SHOW_MORE = 'UnitPresentationDescriptionShowMore';
export const SEARCH_RESULTS_GALLERY_CHANGE_IMAGE = 'SearchResultsGalleryChangeImage';
export const BREADCRUMBS_LINK_CLICK = 'BreadcrumbsLinkClick';
export const CHECKOUT_CANCELLATION_POLICY_OPEN = 'CheckoutCancellationPolicyOpen';
export const HOMEPAGE_LAST_MINUTE_ITEM_SEE_ALL = 'HomepageLastMinuteItemSeeAll';
export const HOMEPAGE_LAST_MINUTE_ITEM = 'HomepageLastMinuteItem';
export const CHECKOUT_DETAILED_PRICE_CALCULATION = 'CheckoutDetailedPriceCalculation';
export const USER_IDENTIFIED = 'user_identified'; // Koristi se i u twigu src/Adriatic/Bundle/ResponsiveFrontendBundle/Resources/views/Shared/headTagManager.html.twig
// Početak "login/sign_up" event-a.
// Napomena: Prilikom uklanjanja/dorade potrebno pregledati i kod u:
// - src/Adriatic/Bundle/ResponsiveFrontendBundle/Resources/views/Shared/socialLoginMacros.html.twig.
// - src/Adriatic/Bundle/ResponsiveFrontendBundle/Infrastructure/Site/UserProvider.php (metoda loadOrCreateFromOAuthProfile).
// Razlog: Dio je odrađen kroz symfony/twig zbog redirect-a prilikom prijave/registracije preko google-a i facebook-a.
export const LOGIN = 'login';
export const SIGN_UP = 'sign_up';
export const LOGIN_OR_REGISTRATION_FORM_MODAL = 'modal';
export const LOGIN_OR_REGISTRATION_FORM_PAGE = 'page';
export const LOGIN_OR_REGISTRATION_METHOD_EMAIL = 'email';
// Kraj "login/sign_up" event-a.
export const HOMEPAGE_SPECIAL_OFFER_BANNER = 'HomepageSpecialOfferBanner';
export const COULD_HAVE_DATES_FROM_LOCAL_STORAGE = 'CouldHaveDatesFromLocalStorage';
export const MANUAL_INPUT_DATES_FROM_LOCAL_STORAGE = 'ManualInputDatesFromLocalStorage';
export const MANUAL_INPUT_DATES_OUTSIDE_LOCAL_STORAGE = 'ManualInputDatesOutsideLocalStorage';
export const HOME_PAGE_VIEW_SPECIAL_OFFER_BANNER = 'HomepageViewSpecialOfferBanner';
export const HOME_PAGE_VIEW_LAST_MINUTE_ITEM = 'HomepageViewLastMinuteItem';
export const ARTICLE_VIEW_LAST_MINUTE_ITEM = 'ArticleViewLastMinuteItem';
export const ARTICLE_LAST_MINUTE_ITEM = 'ArticleLastMinuteItem';
export const ARTICLE_VIEW_ACCOMMODATION_ITEM = 'ArticleViewAccommodationItem';
export const ARTICLE_ACCOMMODATION_ITEM = 'ArticleAccommodationItem';
export const ARTICLE_LAST_MINUTE_ITEM_SEE_ALL = 'ArticleLastMinuteItemSeeAll';
export const ARTICLE_ACCOMMODATION_ITEM_SEE_ALL = 'ArticleAccommodationItemSeeAll';
export const SEARCH_RESULTS_VIEW_EXTRA_OFFER_BANNER = 'SearchResultsViewExtraOfferBanner';
export const SEARCH_RESULTS_EXTRA_OFFER_BANNER = 'SearchResultsExtraOfferBanner';
export const SEARCH_RESULTS_AVAILABILITY_CTA_LINK = 'SearchResultsAvailabilityCTALink';
export const SEARCH_RESULTS_AVAILABILITY_MISSING_LINK = 'SearchResultsAvailabilityMissingLink';
export const SEARCH_RESULTS_VIEW_EXTRA_LOCATIONS = 'SearchResultsViewExtraLocations';
export const SEARCH_RESULTS_EXTRA_LOCATIONS = 'SearchResultsExtraLocations';
export const POPUP_NEWSLETTER_SUBSCRIBE_VIEW = 'PopupNewsletterSubscribeView';
export const POPUP_NEWSLETTER_SUBSCRIBE_SUBMIT = 'PopupNewsletterSubscribeSubmit';
export const CONSENT_BUTTONS_UPDATE = 'ConsentButtonsUpdate';
export const QUICK_SEARCH_DATE_MODE_SELECTED = 'QuickSearchDateModeSelected';
export const QUICK_SEARCH_LOCATION_PROPERTY_SELECTED = 'QuickSearchLocationPropertySelected';
export const QUICK_SEARCH_LOCATION_UNIT_SELECTED = 'QuickSearchLocationUnitSelected';
export const WISHLIST_ICON_CLICK = 'WishlistIconClick';
export const LOGIN_INSERT_EMAIL_POPUP_VIEW = 'LoginInsertEmailPopupView';
export const LOGIN_INSERT_EMAIL_POPUP_GOOGLE_CLICK = 'LoginInsertEmailPopupGoogleClick';
export const LOGIN_INSERT_EMAIL_POPUP_FACEBOOK_CLICK = 'LoginInsertEmailPopupFacebookClick';
export const LOGIN_INSERT_EMAIL_POPUP_SUBMIT = 'LoginInsertEmailPopupSubmit';
export const LOGIN_INSERT_PASSWORD_POPUP_VIEW = 'LoginInsertPasswordPopupView';
export const LOGIN_INSERT_PASSWORD_POPUP_GOOGLE_CLICK = 'LoginInsertPasswordPopupGoogleClick';
export const LOGIN_INSERT_PASSWORD_POPUP_FACEBOOK_CLICK = 'LoginInsertPasswordPopupFacebookClick';
export const LOGIN_INSERT_PASSWORD_POPUP_SUBMIT = 'LoginInsertPasswordPopupSubmit';
export const LOGIN_INSERT_REGISTRATION_POPUP_VIEW = 'LoginInsertRegistrationPopupView';
export const LOGIN_INSERT_REGISTRATION_POPUP_GOOGLE_CLICK = 'LoginInsertRegistrationPopupGoogleClick';
export const LOGIN_INSERT_REGISTRATION_POPUP_FACEBOOK_CLICK = 'LoginInsertRegistrationPopupFacebookClick';
export const LOGIN_INSERT_REGISTRATION_POPUP_SUBMIT = 'LoginInsertRegistrationPopupSubmit';

// INP: tag manager na dataLayer.push sinkrono obrađuje sve triggere i tagove, što bi u click handleru blokiralo
// iscrtavanje odgovora na klik. Push-evi se zato skupljaju u red i šalju istim redoslijedom:
// - nakon sljedećeg painta (runAfterNextPaint, s fallbackom ako rAF ne okine),
// - periodično dok red nije prazan, kao sigurnosna mreža,
// - odmah pri napuštanju/skrivanju stranice, kako se eventi ne bi izgubili pri navigaciji.
const DATA_LAYER_PERIODIC_FLUSH_MS = 1000;
const pendingDataLayerPushes = [];
let isDataLayerFlushScheduled = false;
let dataLayerPeriodicFlushInterval = null;

const flushDataLayerPushes = () => {
    isDataLayerFlushScheduled = false;
    if (dataLayerPeriodicFlushInterval !== null) {
        clearInterval(dataLayerPeriodicFlushInterval);
        dataLayerPeriodicFlushInterval = null;
    }
    if (!pendingDataLayerPushes.length) return;
    window.dataLayer = window.dataLayer || [];
    pendingDataLayerPushes.splice(0).forEach((data) => window.dataLayer.push(data));
};

if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', flushDataLayerPushes);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') flushDataLayerPushes();
    });
}

const pushToDataLayer = (data) => {
    pendingDataLayerPushes.push(data);
    // Skrivena stranica ne dobiva requestAnimationFrame, pa se tada šalje odmah.
    if (document.visibilityState === 'hidden') {
        flushDataLayerPushes();
        return;
    }
    if (dataLayerPeriodicFlushInterval === null) {
        dataLayerPeriodicFlushInterval = setInterval(flushDataLayerPushes, DATA_LAYER_PERIODIC_FLUSH_MS);
    }
    if (isDataLayerFlushScheduled) return;
    isDataLayerFlushScheduled = true;
    runAfterNextPaint(flushDataLayerPushes);
};

const dispatchTrackingEvent = (eventName, additionalData = {}) => {
    if (typeof window === 'undefined') return;
    const eventData = {
        event: eventName,
        ...additionalData,
    };

    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') === 'adriaticaisearch') {
        eventData.ai_search = 1;
    }
    pushToDataLayer(eventData);
};

const dispatchTrackingEventIfConsentGiven = (eventName, additionalData = {}) => {
    if (typeof zaraz === 'undefined' || !zaraz.consent) return;
    const marketing = zaraz.consent.get('KlIi');
    if (!marketing) return;
    dispatchTrackingEvent(eventName, additionalData);
};

const hasGivenMarketingConsent = () => {
    if (typeof zaraz === 'undefined' || !zaraz.consent) return false;
    const marketing = zaraz.consent.get('KlIi');
    if (!marketing) return false;
    return true;
};

const resetEcommerceTrackingContext = () => {
    pushToDataLayer({ ecommerce: null });
};

const dispatchUserIdentified = async (mail) => {
    if (!mail) return;
    const hashedEmail = await getEncryptedEmail(mail);
    dispatchTrackingEvent(USER_IDENTIFIED, { user_email_hashed: hashedEmail });
    // TODO: Potrebno dodati try/catch kad se rijesi import report service-a.
};

// Kreira property-e koji su zajednički za evente koje trenutno koristimo, property-i u return-u su trenutno zajednički u sljedećim event-ima:
// - add_to_wishlist
// - begin_checkout
// - select_item
// - purchase
// - view_item
// - view_item_list
// Dokumentacija: https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
const buildBaseAnalyticsItem = (params) => {
    if (!params || typeof params !== 'object') {
        // reportError(new Error('Nemoguće build-ati item, parametri nisu proslijeđeni u buildBaseAnalyticsItem.'));
        return null;
    }
    const { unitItem } = params;
    if (!unitItem) {
        // reportError(new Error('Nemoguće build-ati item, nedostaje "unitItem" u buildBaseAnalyticsItem.'));
        return null;
    }

    return {
        // Prednost imaju podaci "trackingUnitData", tek ako oni ne postoje idemo na alternative.
        affiliation: 'Adriatic Web',
        item_variant: unitItem.trackingUnitData?.title ?? unitItem.unitShortTitle ?? unitItem.title ?? unitItem.unitTitle ?? '', // Sifra jedinice.
        item_brand: unitItem.trackingUnitData?.rivieraCroatianTitle ?? '',
        item_id: String(unitItem.trackingUnitData?.unitId ?? unitItem.unitId ?? unitItem.itemId ?? ''), // Po dokumentaciji je string - "itemId" dolazi sa assets/responsive-frontend/js/parts/featuredAccommodation.jsx, TODO: bilo bi dobro standardizirat.
        item_name: unitItem.trackingUnitData?.fullTitle ?? unitItem.fullTitle ?? '',
        price: parseFloat(unitItem.priceWithDiscount?.toFixed(2)) || 0,
        discount: parseFloat(unitItem.discount?.toFixed(2)) || 0,
        item_group_id: unitItem.trackingUnitData?.facilityId ?? '',
    };
};

export default dispatchTrackingEventIfConsentGiven;
export { dispatchTrackingEvent, hasGivenMarketingConsent, resetEcommerceTrackingContext, dispatchUserIdentified, buildBaseAnalyticsItem };
